module.exports = __webpack_public_path__ + "assets/dojo.ad49ea0a.svg";